import { render, staticRenderFns } from "./Fruit.vue?vue&type=template&id=1ce7523c&scoped=true"
import script from "./Fruit.vue?vue&type=script&lang=js"
export * from "./Fruit.vue?vue&type=script&lang=js"
import style0 from "./Fruit.vue?vue&type=style&index=0&id=1ce7523c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce7523c",
  null
  
)

export default component.exports